module.exports = __webpack_public_path__ + "media/images/ic-index-lookup-96fc9cc557879df883fd0e1254550caa.svg";